<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="CommandsCollection"
  />
</template>

<script>
import { DropDownSectionConsts } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import CommandTypes from 'client/Commands/constants/CommandTypes';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const {
  selectOne,
} = DropDownSectionConsts;

const {
  linux,
  windows,
  mac,
} = CommandTypes;

const formatDisplayValue = str => str.charAt(0).toUpperCase() + str.slice(1);

export default {
  name: 'CommandsDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    return {
      dropDownMenuSections: [
        {
          menuLabel: 'command OS:',
          menuType: selectOne,
          menuItems: [
            {
              filter: this.commandsOS(windows),
              label: 'Windows',
              action: () => {
                this.handleDropDownAction(this.commandsOS(windows));
              },
            },
            {
              filter: this.commandsOS(mac),
              label: 'Mac',
              action: () => {
                this.handleDropDownAction(this.commandsOS(mac));
              },
            },
            {
              filter: this.commandsOS(linux),
              label: 'Linux',
              action: () => {
                this.handleDropDownAction(this.commandsOS(linux));
              },
            },
          ],
        },
      ],
    };
  },

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters('CommandsCollection', [
      'getFilters',
    ]),
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions('CommandsCollection', [
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),

    commandsOS: os => ({
      name: 'commandType',
      operator: 'eq',
      value: os,
      type: 'OS',
      displayValue: formatDisplayValue(os),
    }),
  },
};
</script>
